<template>
  <div class="home">
    <Tabs  v-model="showTab">
      <Tab title="待审核流程" name="1"></Tab>
      <Tab title="已审核流程" name="2"></Tab>
    </Tabs>
    <Search v-model="q" placeholder="请输入搜索关键词" @search="search" @clear="search" />
    <List v-model="loading"
    :finished="finished"
    finished-text="没有更多了" @load="getList">
      <Approval v-for="item in items" :key="item.id" :data="item" @click.native="$router.push(`/approvals/${item.id}`)"></Approval>
    </List>
  </div>
</template>

<script>

import Approval from '@/components/Approval'
import { Tab, Tabs, Toast, List, Search } from 'vant'
import http from '../../utils/http'
export default {

  components: {
    Approval,
    Tab,
    Tabs,
    List,
    Search
  },
  data () {
    return {
      items: [],
      showTab: '1',
      loading: false,
      finished: false,
      q: ''
    }
  },
  watch: {
    showTab: {
      handler () {
        this.items = []
        this.finished = false
        this.q = ''
        this.getList()
      },
      immediate: true
    }
  },
  methods: {
    getList () {
      this.loading = true
      Toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      })
      return http.post('/approval/apply/list-new', { type: this.showTab, q: this.q, pagination: { page: parseInt(this.items.length / 20) } }).then(({ list, total }) => {
        this.items.push(...list)
        // this.total = total
        this.finished = this.items.length === total
        Toast.clear()
      }).finally(() => {
        this.loading = false
      }).catch(() => {
        this.finished = true
      })
    },
    search () {
      this.items = []
      this.finished = false
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .approval + .van-list__finished-text {
  margin-top: -15px;
}
</style>
